var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.params.slug)?_c('Breadcrumb',{key:_vm.$route.path,attrs:{"title":_vm.$route.params.slug}}):_vm._e(),_vm._v("Single Event info here: "),_c('br'),_c('br'),_vm._v(_vm._s(_vm.$route.params.slug)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }